import { render } from "./AppDash.vue?vue&type=template&id=3984c1df"
import script from "./AppDash.vue?vue&type=script&lang=js"
export * from "./AppDash.vue?vue&type=script&lang=js"

import "./AppDash.vue?vue&type=style&index=0&id=3984c1df&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__